const keycloakConfig = {
    url: __SSO_URL__,
    realm: __SSO_REALM__,
    clientId: __SSO_CLIENT_ID__,
};

export default keycloakConfig;



// WEBPACK FOOTER //
// ./src/components/login/sso/keycloakConfig.js